export default "__VITE_ASSET__D_Ih7Xc8__"